import React from "react";
import "./Terms.css";

export default function Terms() {
  return (
    <div className="terms-container">
      <h1>TERMS & CONDITIONS</h1>
      {/* <p><strong>Last Updated:</strong> [Date]</p> */}

      <p>
        Welcome to JENIZO IT TECH PVT LTD. By accessing or using our website, 
        services, or products, you agree to the Terms & Conditions listed below. 
        Please read them carefully.
      </p>

      <hr />

      <h2>1. Acceptance of Terms</h2>
      <p>
        By using our website, purchasing services, registering for our programs, 
        or interacting with our platform, you agree to follow all Terms & Conditions, 
        Privacy Policy, Refund Policy, and Service Agreements.
      </p>

      <hr />

      <h2>2. Services Provided</h2>
      <p>JENIZO IT TECH PVT LTD provides the following services:</p>
      <ul>
        <li>Website development</li>
        <li>Mobile app development</li>
        <li>UI/UX design</li>
        <li>Digital marketing & automation</li>
        <li>Software solutions</li>
        <li>Internship & training programs</li>
        <li>Maintenance & support services</li>
      </ul>
      <p>The company may update, modify, or discontinue services at any time.</p>

      <hr />

      <h2>3. Client Responsibilities</h2>
      <ul>
        <li>Provide accurate information</li>
        <li>Respond to the team on time</li>
        <li>Share required content (logo, text, images)</li>
        <li>Clear payments as per the invoice</li>
        <li>Not misuse or resell company materials</li>
      </ul>

      <hr />

      <h2>4. Payment Terms</h2>
      <ul>
        <li>All payments must be made in advance unless otherwise agreed.</li>
        <li>Service will begin only after minimum required payment is received.</li>
        <li>Late payments may cause project delays.</li>
        <li>GST and additional taxes may apply.</li>
      </ul>

      <hr />

      <h2>5. Refund Policy</h2>
      <ul>
        <li>No refund once work has started.</li>
        <li>Digital products are non-refundable.</li>
        <li>Training & internship fees are non-refundable.</li>
        <li>Technical issues will be fixed at no extra cost.</li>
      </ul>

      <hr />

      <h2>6. Project Timeline</h2>
      <p>Timelines are estimates and may extend due to:</p>
      <ul>
        <li>Late content submission</li>
        <li>Client approval delays</li>
        <li>External technical issues</li>
      </ul>

      <hr />

      <h2>7. Intellectual Property</h2>
      <p>
        All code, designs, documents, and materials created by JENIZO IT TECH PVT LTD 
        remain the property of the company unless officially transferred. Clients are 
        given rights only to use the final product.
      </p>
      <p>Reuse, resale, or copying is strictly prohibited.</p>

      <hr />

      <h2>8. Confidentiality</h2>
      <p>Both parties agree to keep the following confidential:</p>
      <ul>
        <li>Business data</li>
        <li>Client details</li>
        <li>Source code</li>
        <li>Strategies & pricing</li>
      </ul>
      <p>Any violation may result in legal action.</p>

      <hr />

      <h2>9. Service Limitations</h2>
      <p>We are not responsible for:</p>
      <ul>
        <li>Third-party API or plugin failures</li>
        <li>Hosting/server downtime</li>
        <li>Client mistakes or mismanagement</li>
        <li>Marketing, ad, or SEO results</li>
      </ul>

      <hr />

      <h2>10. Website & App Delivery</h2>
      <ul>
        <li>Client must check all work within 7 days of delivery.</li>
        <li>Issues reported within 7 days will be fixed free.</li>
        <li>After 7 days, maintenance charges apply.</li>
      </ul>

      <hr />

      <h2>11. Maintenance Policy</h2>
      <ul>
        <li>Support hours are limited under monthly plans.</li>
        <li>Additional work will be charged extra.</li>
        <li>Major feature updates require a new quotation.</li>
      </ul>

      <hr />

      <h2>12. Internship & Course Terms</h2>
      <ul>
        <li>No job guarantee is provided.</li>
        <li>Certificates depend on performance.</li>
        <li>Fees are non-refundable.</li>
        <li>Misuse of training materials is prohibited.</li>
      </ul>

      <hr />

      <h2>13. Prohibited Actions</h2>
      <ul>
        <li>Hacking or damaging the website</li>
        <li>Copying or reselling materials</li>
        <li>Spamming</li>
        <li>Illegal activities</li>
      </ul>
      <p>Violations may result in permanent ban + legal action.</p>

      <hr />

      <h2>14. Limitation of Liability</h2>
      <p>
        JENIZO IT TECH PVT LTD is not liable for loss of revenue, business, or data. 
        Total liability is limited to the amount paid by the client.
      </p>

      <hr />

      <h2>15. Agreement Updates</h2>
      <p>
        We may modify these Terms anytime. Continuing to use our services means 
        acceptance of the updated version.
      </p>

      <hr />

      <h2>16. Contact Information</h2>
      <p>
        <strong>JENIZO IT TECH PVT LTD</strong><br />
        Email: info@jenizo.in<br />
        Phone: +91 8179785211<br />
        Hyderabad, Telangana, India
      </p>
    </div>
  );
}

